var _defs, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 88,
    id: "svg_9_filter",
    width: 88,
    x: -4.09,
    y: -3
  }, /*#__PURE__*/React.createElement("feBlend", {
    id: "svg_19",
    in2: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    id: "svg_20",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_403_3923"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 31,
    id: "mask0_403_3923",
    maskUnits: "userSpaceOnUse",
    width: 31,
    x: 24,
    y: 23
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.91,
    cy: 38.5,
    fill: "white",
    id: "svg_2",
    r: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.56,
    cy: 39.85,
    fill: "#8BA293",
    id: "svg_4",
    r: 15,
    transform: "matrix(1, 0, 0, 1, 0, 0) matrix(0.66782, 0, 0, 0.66782, -15.9664, -12.9029)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.03,17.22c5.25,-1.6 6.8,4.64 9.59,-3.4c0.25,-5.44 -4.02,-8.24 -6.18,-8.97c-1.34,1.24 -4.51,3.77 -6.49,4.02c-2.47,0.31 0.31,4.33 -2.16,5.26c-2.47,0.93 -0.62,4.88 5.26,3.09z",
    fill: "#EFF4F1",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.12,20.51c-4.45,-1.73 -6.8,-0.93 -7.73,0c6.18,5.2 12.47,2.99 14.84,1.24c-0.31,0.11 -2.66,0.49 -7.11,-1.24z",
    fill: "#EFF4F1",
    filter: "url(#svg_7_filter)",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.71,0.85c-0.85,-0.12 -1.66,-0.04 -2.42,0.42c-1.45,0.88 -1.98,2.27 -1.6,4.28c0.55,1.55 1.44,2.9 2.49,4.14c0.65,0.77 1.14,0.77 1.74,-0.03c1.11,-1.24 1.96,-2.65 2.52,-4.24c0.01,-0.12 0.02,-0.25 0.04,-0.37c0.32,-2.02 -0.83,-3.74 -2.78,-4.19z",
    fill: "#FFA692",
    filter: "url(#svg_8_filter)",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.01,
    cy: 30.62,
    fill: "#EFF4F1",
    filter: "url(#svg_9_filter)",
    id: "svg_9",
    r: 3,
    transform: "matrix(0.500914, 0, 0, 0.500914, -3.92602, -11.2582)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaises);
export default __webpack_public_path__ + "static/media/paises.5ff1d884b399c0413ca00bfa4906a68c.svg";
export { ForwardRef as ReactComponent };